import styled from '@emotion/styled';

const MessageWrapper = styled('h3')({
  display: 'inline-flex',
  alignItems: 'center',
});

export default MessageWrapper;
